<template>
    <el-select
        :value="value"
        class="resource-filter"
        @change="onChange"
    >
        <el-option
            v-for="option in options"
            :key="option.value"
            :label="option.label"
            :value="option.value"
            :data-cy="`resourcesFilterOption-${option.value}`"
        />
    </el-select>
</template>

<script>
/**
 * Phase 2 / §2.7 — Resources filter dropdown.
 *
 * Two-option el-select chosen over el-radio-group for visual
 * symmetry with the sort dropdown from Story 3.3 / 3.4 — both sit
 * above paginated lists and use the same el-select-dropdown surface.
 *
 * v-model compatible: emits `input` on change so the parent can
 * persist the selection (Resources.vue writes it to ?filter= via
 * vue-router).
 */

const FILTER_OPTIONS = [
    { value: 'all', label: 'All' },
    { value: 'surveyor', label: 'Surveyor Only' },
]

export default {
    name: 'ResourceFilter',
    props: {
        value: {
            type: String,
            default: 'all',
            validator: v => FILTER_OPTIONS.some(o => o.value === v),
        },
    },
    data() {
        return { options: FILTER_OPTIONS }
    },
    methods: {
        onChange(value) {
            this.$emit('input', value)
        },
    },
}
</script>
